// eslint-disable-next-line
import configJson from './config.json';

export default configJson;
